module.exports = "/call-frontend/img/撒点-橙.8fa68edd.png";